<template>
    <div class="container-scroller login-page" id="login-page">
        <b-container fluid class="page-body-wrapper full-page-wrapper">
            <div class="content-wrapper d-flex align-items-center auth">
                <b-row class="flex-grow">
                    <b-col lg="7" md="12" sm="12" class="mx-auto">
                        <b-row class="auth-form-light text-left">
                            <b-col class="col-lg-6 left-side col-md-12 col-sm-12">
                                <div class="brand-logo text-center">
                                    <img :src="imageUrl" height="150px" width="150px" alt="logo">
                                </div>
                                <template v-if="submitted">
                                    <b-card-text class="text-center text-muted mb-4 mt-4">
                                        <h5 class="display-4">{{ $translate('password_changed') }}</h5>
                                    </b-card-text>
                                    <b-card-text class="text-center text-muted mb-4 mt-4">
                                        {{ $translate('click_below_to_login') }}
                                    </b-card-text>
                                    <b-row class="justify-content-center">
                                        <b-button variant="facebook" class="auth-form-btn col-6" block
                                            @click="backToLogin()">{{ $translate('back_to_login') }}</b-button>
                                    </b-row>
                                </template>
                                <template v-else>
                                    <b-card-text class="text-center text-muted mb-2 mt-4">
                                        <h3>{{ $translate('reset_password') }}</h3>
                                    </b-card-text>
                                    <b-card-text class="text-center text-muted mb-4">
                                        <small>{{ $translate('reset_password_note') }}</small>
                                    </b-card-text>
                                    <b-alert variant="delete-button" :show="errors.has('token')">{{
                                        errors.first('token')
                                    }}</b-alert>

                                    <b-form role="form" @submit.prevent="submit">
                                        <input type="hidden" name="token" />
                                        <b-form-group class="mb-2">
                                            <b-form-input v-model="model.email" :placeholder="$translate('email')" required
                                                type="email" id="forgot-password-email" v-custom-validation="$emailRequired()"> 
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group ref="password" class="mb-2">
                                            <b-input-group class="password-field-container">
                                                <b-form-input :type="showPassword ? 'text' : 'password'" id="forgot-password-password"
                                                :placeholder="$translate('password')" v-custom-validation="$textRequired()"
                                                v-model="model.password" required>
                                            </b-form-input>
                                            <b-input-group-append class="eye-btn">
                                                    <i @click="showPassword = !showPassword"
                                                        :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>

                                                </b-input-group-append>
                                            </b-input-group>
                                            <p class="muted-text">{{ $translate('password_pattern') }}</p>
                                        </b-form-group>
                                        <b-form-group type="password" class="mb-2">
                                            <b-input-group class="password-field-container">
                                                <b-form-input :type="showRetypePassword ? 'text' : 'password'" :placeholder="$translate('retype_password')"
                                                v-custom-validation="$textRequired()" v-model="model.password_confirmation"
                                                id="forgot-password-confirm-password" required></b-form-input>
                                                <b-input-group-append class="eye-btn">
                                                    <i @click="showRetypePassword = !showRetypePassword"
                                                        :class="showRetypePassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>

                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                        <div class="d-flex justify-content-center my-4">
                                            <b-button block type="submit" class="auth-form-btn col-12" variant="facebook"
                                                :disabled="submitting ? true : false">{{
                                                    submitting
                                                    ? $translate('submitting')
                                                    : $translate('recover_password')
                                                }}</b-button>
                                        </div>
                                    </b-form>
                                </template>
                            </b-col>
                            <div class="col-lg-7 bg-white slider-bar col-md-12 col-sm-12">
                                <Slider :sliderImages="sliderImages" :isCustomerLoginPage="true" />
                            </div>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
        </b-container>
    </div>
</template>
<script>
import api from '@/api/auth'
import Slider from '@/components/Login/slider.vue'
import popupMixins from '@/mixins/popupMixins'
import logoImage from '@/assets/images/logo.png'

export default {
    name: 'change-password',
    data() {
        return {
            submitting: false,
            signInError: false,
            submitted: false,
            model: {
                email: null,
                password: null,
                password_confirmation: null,
            },
            showPassword: false,
            showRetypePassword: false,
        }
    },
    mixins: [popupMixins],
    components: { Slider },
    async created() {
        this.$store.dispatch('company/fetch')
    },
    computed: {
        imageUrl() {
            let imageUrl
            const data = this.$store.state.company.settings || {}
            if (data && data.logo) {
                imageUrl = JSON.parse(data.logo).url
            } else {
                imageUrl = logoImage
            }
            return imageUrl
        },
        sliderImages() {
            return this.$store.state.company.settings && this.$store.state.company.settings.company_images && this.$store.state.company.settings.company_images.map(item => item.url) || {}
        },
    },
    methods: {
        async submit() {
            try {
                this.submitting = true
                const valid = await this.$validator.validate();
                if (!valid) {
                    throw new Error(this.$translate("invalid"))
                }
                const { token } = this.$route.query
                const { email,
                    password,
                    password_confirmation, } = this.model
                if (password !== password_confirmation) {
                    throw new Error(this.$translate("password_not_matched"))
                }
                const data = {
                    email,
                    password,
                    password_confirmation,
                    token,
                }
                console.log("data:--", data)
                await api.resetPassword(data)
                // route to dashboard
                this.submitted = true
                this.doToast(
                    this.$translate('success'),
                    this.$translate('password_reset_successfully'),
                    'success'
                )
            }
            catch (error) {
                console.error("submit", error)
                this.doToast(
                    this.$translate('error'),
                    `${error.message || this.$translate('system_error_detected')}`,
                    'danger'
                )
            }
            finally {
                this.submitting = false
            }
        },

        backToLogin() {
            this.$router.push('/login')
        },
    },
}
</script>
<style scoped>
.eye-btn{
    right: 15px;
    top: 18px;
}
</style>
